import { ProductCreateRequestTypeBadgeType } from "@sellar-io/api-v2/types";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import {
  Button,
  InputField,
  InputOption,
  InputSelect,
  InputText,
} from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useProductCreate } from "../../../../hooks/api/v2/product/useProductCreate";
import { PRODUCT_LIST_CATEGORY } from "../../../../constants/routes";
import { useParamAsNumber } from "../../../../hooks/useParamAsNumber";

export const BadgeItemModal = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  const productId = useParamAsNumber(PRODUCT_LIST_CATEGORY, "productId");

  const { register, handleSubmit } = useForm<ProductCreateRequestTypeBadgeType>(
    {
      defaultValues: {
        sku: null,
        shape: undefined,
      },
      shouldUseNativeValidation: true,
    },
  );

  const productCreateMutation = useProductCreate();

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        onClickLeftIcon={onDismiss}
        title={"Add badge"}
        leftIcon={"CHEVRON_DOWN"}
      />
      <DialogContent className={"p-4"}>
        {productCreateMutation.isError && (
          <Alert
            message={
              apiV2AssertError(productCreateMutation.error)?.response?.data
                .message ?? "Unknown error"
            }
          />
        )}

        <form
          onSubmit={handleSubmit((data) => {
            productCreateMutation.mutate(
              {
                type: "badge",
                shape: data.shape,
                sku: data.sku,
                ParentId: productId,
              },
              {
                onSuccess: () => {
                  onDismiss();
                },
              },
            );
          })}
          className={"flex flex-col gap-2"}
        >
          <InputField label={"Badge type"}>
            <InputSelect {...register("shape", { required: true })}>
              <InputOption value="" disabled hidden>
                Choose...
              </InputOption>
              <option value={"oval"}>Keg Badge - Oval</option>
              <option value={"square"}>Keg Badge - Square</option>
              <option value={"circle"}>Keg Badge - Circle</option>
              <option value={"ovalFisheye"}>Keg Fisheye Lens - Oval</option>
              <option value={"circleFisheye"}>Keg Fisheye Lens - Circle</option>
              <option value={"pumpClip"}>Cask Badge - Pump clip</option>
            </InputSelect>
          </InputField>
          <InputField label={"SKU"}>
            <InputText
              {...register("sku", { required: false })}
              placeholder={"Optional"}
            />
          </InputField>
          <DialogCTA>
            <Button type={"submit"} loading={productCreateMutation.isPending}>
              Confirm
            </Button>
          </DialogCTA>
        </form>
      </DialogContent>
    </Dialog>
  );
};
